.toast {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  padding: 0.75rem 1rem;
  border: 1px solid var(--toast-color);
  border-left-width: 3px;
  border-radius: var(--radius-sharp);
  background: var(--card);
  color: var(--ink);
  box-shadow: var(--shadow-soft);
}

.info {
  --toast-color: var(--line);
}

.ok {
  --toast-color: var(--ok);
}

.error {
  --toast-color: var(--stop);
}
